import React from 'react';
import './Notification.css';

const Notification = ({ type, message, onClose }) => {
  if (!message) return null;

  return (
    <div className={`notification ${type}`}>
      <span>{message}</span>
      <button className="close-btn" onClick={onClose}>&times;</button>
    </div>
  );
};

export default Notification;